import { render } from "./WeekOrders.vue?vue&type=template&id=1fb8ab7a"
import script from "./WeekOrders.vue?vue&type=script&lang=ts"
export * from "./WeekOrders.vue?vue&type=script&lang=ts"
script.render = render

export default script